import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);

export default {
  lista: idProjeto => {
    return Vue.http.get(`/api/servicosprojeto?idProjeto=${idProjeto}`)
      .then(response => response.data);
  },
};



// WEBPACK FOOTER //
// ./FrontEnd/modulos/servico-projeto/servico.js